<template>
  <PageWrapper
    :active-section="SECTION_COMMUNITY"
    :active-page="PAGE_VIDEO_EDITORS"
    title="Video Editors"
    sub-title=""
    :breadcrumbs="breadcrumbs"
    page-name="Video Editors"
    align="left"
    width="fixed"
  >
    <SmartFeed
      :source="useOrgCommunityVideoExpertiseFeedStore"
      default-entity-size="large"
      default-feed-layout="grid"
      load-more-behavior="auto"
      :show-filters="false"
    >
      <template #empty-state>
        <iSpace :height="10" />
        <iColumn gap="large" align="center">
          <iColumn gap="standard" align="center">
            <iSubHeading variant="subtle" font-size="large">
              No video editors found
            </iSubHeading>
            <iParagraph
              variant="subtle"
              text-align="center"
              :max-width="400"
            >
              There are currently no video editors available in the community
            </iParagraph>
          </iColumn>
        </iColumn>
      </template>
    </SmartFeed>
  </PageWrapper>
</template>

<script>
import PageWrapper from "@/components/PageWrapper";
import {
  SECTION_COMMUNITY,
  PAGE_VIDEO_EDITORS,
} from "@/constants/nav-constants";
import SmartFeed from "SmartFeed/components/SmartFeedV2.vue";
import {
  useOrgCommunityVideoExpertiseFeedStore,
} from "SmartFeed/stores/feed/org-community-video-expertise-feed-store";

export default {
  name: "VideoEditors",
  components: {
    SmartFeed,
    PageWrapper,
  },
  data() {
    return {
      SECTION_COMMUNITY,
      PAGE_VIDEO_EDITORS,
    };
  },
  computed: {
    breadcrumbs() {
      return [
        { url: "/", label: "Home" },
        { url: "/community", label: "Community" },
        { url: "/experts", label: "Experts" },
      ];
    },
  },
  methods: { useOrgCommunityVideoExpertiseFeedStore },
};
</script>

